import type { UgcInvoiceDataRecord } from "../lib/ugcInvoice";
import { getSupabase } from "./client";

export type UgcInvoiceSnapshotRow = {
  id: string;
  created_at: string;
  invoice_date: string;
  document_number: string;
  scope_b_period_label: string;
  bill_to_email: string | null;
  remitter_line: string | null;
  generated_at: string;
  payload_json: UgcInvoiceDataRecord;
  plain_text: string;
};

export type UgcInvoiceSnapshotInsert = {
  invoice_date: string;
  document_number: string;
  scope_b_period_label: string;
  bill_to_email: string | null;
  remitter_line: string | null;
  generated_at: string;
  payload_json: UgcInvoiceDataRecord;
  plain_text: string;
};

export async function insertUgcInvoiceSnapshot(
  row: UgcInvoiceSnapshotInsert
): Promise<{ error: string | null }> {
  const sb = getSupabase();
  if (!sb) return { error: "Supabase is not configured." };
  const { error } = await sb.from("ugc_reimbursement_invoice_snapshots").insert({
    invoice_date: row.invoice_date,
    document_number: row.document_number,
    scope_b_period_label: row.scope_b_period_label,
    bill_to_email: row.bill_to_email,
    remitter_line: row.remitter_line,
    generated_at: row.generated_at,
    payload_json: row.payload_json,
    plain_text: row.plain_text,
  });
  return { error: error?.message ?? null };
}

export async function listUgcInvoiceSnapshots(
  limit = 50
): Promise<{ data: UgcInvoiceSnapshotRow[] | null; error: string | null }> {
  const sb = getSupabase();
  if (!sb) return { data: null, error: "Supabase is not configured." };
  const { data, error } = await sb
    .from("ugc_reimbursement_invoice_snapshots")
    .select("*")
    .order("created_at", { ascending: false })
    .limit(limit);
  if (error) return { data: null, error: error.message };
  return { data: (data ?? []) as UgcInvoiceSnapshotRow[], error: null };
}
